import React, { useState, useEffect } from 'react'
import ReactMarkdown from 'react-markdown'
import fetch from 'isomorphic-unfetch'

// Components
import { Seo, Footer } from '../../components'

// Styled Components
import { PageWrapper, ContentWrapper } from '../../styles/layout'

import pgContent from './content.md'

const About = () => {
  const [content, setContent] = useState(null)

  const fetchContent = async () => {
    const response = await fetch(pgContent)
    const text = await response.text()
    setContent(text)
  }

  useEffect(() => {
    fetchContent()
  }, [])

  // useEffect(() => {
  //   fetch(md)
  //     .then(res => res.text())
  //     .then(text => setContent(text))
  // }, [])

  return (
    <PageWrapper>
      <Seo
        title="About"
        slug="about"
        keywords={['about']}
        description="Find out more about why we made SVG Artista and what can it do for you."
      />

      {/* Main Content */}
      <ContentWrapper
        className="page-content"
        as={ReactMarkdown}
        source={content}
        escapeHtml={false}
        linkTarget={(url) => url.match(/https?:\/\//) && '_blank'}
        // linkTarget={(url, text, title) => url.match(/https?:\/\//) && '_blank'}
      />

      {/* Footer */}
      <Footer />
    </PageWrapper>
  )
}

export default About
